module.exports = __webpack_public_path__ + "img/bhlogo.349409da.png";